import { Col } from "antd";
import { Md5 } from "md5-typescript";
import { useCallback, useMemo } from "react";

import { calculateFreeSpace, createViewColumn } from "../Helpers";
import { DeleteButton, EditButton, ListRow } from "../styles/Styles";
import type { EditableItem } from "../types/EditableItem";
import type { EditableItemViewProps } from "../types/EditableItemViewProps";

export const EditableListItemView = <T extends EditableItem>(props: EditableItemViewProps<T>) => {
    const { value, onChange, columns, canRemove, canEdit } = props;

    const onEditCallback = () => {
        if (!onChange) {
            return;
        }

        const updatedItem = {
            ...value,
            isEditing: true,
        };
        onChange(updatedItem);
    };
    const onDeleteCallback = () => {
        if (!onChange) {
            return;
        }
        onChange(null);
    };

    const key = useMemo(() => {
        return value?.index === undefined ? Md5.init(JSON.stringify(value)) : value.index;
    }, [value]);
    const editAction = (
        <EditButton name="editableList_edit_button" onClick={onEditCallback} key={`${key}-EditButton`}>
            Edit
        </EditButton>
    );
    const deleteAction = (
        <DeleteButton name="editableList_delete_button" onClick={onDeleteCallback} key={`${key}-DeleteButton`}>
            Delete
        </DeleteButton>
    );
    const actions = [];
    if (canRemove) {
        actions.push(deleteAction);
    }

    if (canEdit) {
        actions.push(editAction);
    }

    const freeSpace = useCallback(() => {
        return calculateFreeSpace(columns || []);
    }, [columns]);

    return (
        (value && (
            <ListRow key={`${key}-ListRowRow`}>
                {columns?.map((col) => createViewColumn(col, value))}
                <Col span={freeSpace()} key={`${key}-ListRowActions`}>
                    {actions}
                </Col>
            </ListRow>
        )) ||
        null
    );
};
